import { styled } from '@mui/material/styles'
import Chip from '@mui/material/Chip'

export const Wrapper = styled('div')({})

export const StyledChip = styled(Chip)(({ theme }) => ({
  '&.MuiChip-root': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    '& .MuiChip-deleteIcon': {
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.dark,
      },
    },
  },
}))
